var ur = window.location.href;
if(ur.includes('/collection')){
 jQuery(document).ready(function(){
     jQuery(document).scroll(function() {
   document.dispatchEvent(new CustomEvent('qview-grid-updated'));
}); 
$('.template-collection .quick-product__btn').click(function(e){
  e.preventDefault();
  e.stopPropagation();



var t = $(this);
    var qq = 0; var timerqq = setInterval(function(){
  if(t.parent().find('.qview-button').length) {
	t.parent().find('.qview-button').eq(0).click();
clearInterval(timerqq);}if( qq > 200){clearInterval(timerqq);}qq++;}, 50);
}); 
}); 
}

var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

   var afff = 0; var timerafff = setInterval(function(){
  if($('afterpay-placement').length) {
	$('span#shopify-zip-prod-widget').eq(0).before($('afterpay-placement').eq(0))
clearInterval(timerafff);}if( afff > 200){clearInterval(timerafff);}afff++;}, 50);
 if(jQuery('.fh-buyNow').length == 0){
     jQuery('.add-to-cart.btn--secondary').eq(0).after(jQuery('<div class="fh-buyNow">BUY NOW</div>'));
 }

  jQuery('.fh-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
}); 
}

var ur = window.location.href;
if(ur.includes('/product')){
  
 jQuery(document).ready(function(){
   
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};

var imgSrcs = ['https://cdn.shopify.com/s/files/1/0025/1065/1467/files/email_180x.png?v=1613577090',  
'https://cdn.shopify.com/s/files/1/0025/1065/1467/files/return_1_180x.png?v=1613577092', 
'https://cdn.shopify.com/s/files/1/0025/1065/1467/files/free-delivery_180x.png?v=1613577090'];

var badgeTexts = ["14 Days Money Back Guarantee",
                  "Easy 4 Steps Return",
                  "See Free Shipping Offer"];
    
var popup = ["simple-organic",   "simple-return", "simple-shipping"] // dito yung id ng text
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.payment-buttons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  var prodName = jQuery('h1.product_name').html();
  
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="'+imgSrcs[i] +'"><span class="badge'+i+'" id="'+popup[i]+'">'+badgeTexts[i]+'</span></div>';

    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
});
  
  
jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  
      
    // div ng popup  
    // take note class at id
    
    $('.collapsible-trigger--inline').click(function(){
  $(this).toggleClass('is-open');
      $(this).next().toggleClass('is-open');
}); 
  jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-returns-popup').eq(0).addClass('open')
  });   
    jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
  });   
      
 jQuery('span.simple-close').click(function(){
  jQuery(this).closest('.simple-returns-popup').removeClass('open')
   jQuery(this).closest('.simple-shipping-popup').removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body  .open').length){
       jQuery('span.simple-close').click();
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
  
}



var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = ".add-to-cart.btn--secondary";
  var selectorClass = ".variant-input-wrap";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"> <div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name').html(jQuery('.product-single__title').eq(0).html());
  jQuery('.simple-product-name').append(jQuery('.jdgm-widget.jdgm-preview-badge').eq(0).clone());
  
 
function populateOptions(select, labels){
  var selected = 0;
  labels = labels.eq(0).find('input');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
    
      var t = document.createTextNode(labels.eq(i).val());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    if(labels.eq(i).attr('checked')){
      selected = i;
    }
    	if(i ==0){
          select.removeChild(select.firstElementChild);
          
          
        }
    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.simple-st-item__button').click(function(){
   if(!jQuery('.simple-st-item__button').hasClass("simple-st-disabled")){
     
      jQuery(btnClass).eq(0).click();
      }
    
   
  });
  
 if(jQuery(selectorClass).eq(0).length >= 1){
 
   jQuery('.simple-st-select span').eq(0).html(jQuery(selectorClass).eq(0).attr('name'));
  jQuery('#st-select0').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery(selectorClass).eq(0));
}
    
  
 if(jQuery(selectorClass).eq(1).length >= 1){
 
   jQuery('.simple-st-select span').eq(1).html(jQuery(selectorClass).eq(1).attr('name'));
  jQuery('#st-select1').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery(selectorClass).eq(1));
}
    
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery(btnClass + ' span').eq(0);
             jQuery('.simple-st-item__button').html(elem.html());
             if (elem.html().toUpperCase().trim() != 'ADD TO CART') {
                 jQuery('.simple-st-item__button').html(elem.html());
                 jQuery('.simple-st-item__button').addClass('simple-st-disabled');
             } else {
                 jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
             }
         }, 100);
     }
//checkIfDisabled();
  jQuery('.r > label').click(function(){
   		checkIfDisabled();
});
jQuery('#st-select0 > select').change(function(){
  checkIfDisabled();
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('.variant-input-wrap:eq(0) input').eq(i).click();
 
});
jQuery('#st-select1 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('.variant-input-wrap:eq(1) input').eq(i).click();
  
});
jQuery('#st-select2 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('.swatch:eq(2) input').eq(i).click();
  
});
  
jQuery('.variant-input-wrap:eq(0) input').click(function(){
checkIfDisabled();
 jQuery('#st-select0 > select').val(jQuery(this).val());
});
  
jQuery('.variant-input-wrap:eq(1) input').click(function(){
checkIfDisabled();
 jQuery('#st-select1 > select').val(jQuery(this).val());
});
  jQuery('.selector-wrapper:eq(2) select').change(function(){
 jQuery('#st-select2 > select').val(jQuery(this).val());
});
    
    
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}

